import {
  AccessTimeOutlined,
  ApartmentOutlined,
  DashboardOutlined,
  ExtensionOutlined,
  SmartToyOutlined,
  StarOutline,
  EventAvailableOutlined,
} from '@mui/icons-material';

export const SETTINGS_PATHS = {
  overview: '/configuracoes',
  units: '/configuracoes/unidades',
  hours: '/configuracoes/horarios',
  products: '/configuracoes/produtos',
};

export const SETTINGS_NAV_ITEMS = [
  { label: 'Visão geral', path: SETTINGS_PATHS.overview, icon: DashboardOutlined, exact: true },
  { label: 'Unidades', path: SETTINGS_PATHS.units, icon: ApartmentOutlined },
  { label: 'Horários', path: SETTINGS_PATHS.hours, icon: AccessTimeOutlined },
  { label: 'Produtos e integrações', path: SETTINGS_PATHS.products, icon: ExtensionOutlined },
];

export const DAY_LABELS = [
  'Domingo',
  'Segunda-feira',
  'Terça-feira',
  'Quarta-feira',
  'Quinta-feira',
  'Sexta-feira',
  'Sábado',
];

export const PRODUCT_METADATA = {
  atendabot: {
    name: 'Atendabot',
    description: 'Chatbot de atendimento via WhatsApp',
    icon: SmartToyOutlined,
    color: '#2563eb',
    background: '#eff6ff',
    settingsPath: '/atendabot/prompt',
  },
  clube_mesa: {
    name: 'Clube de Mesa',
    description: 'Programa de fidelidade e check-in',
    icon: StarOutline,
    color: '#16a34a',
    background: '#f0fdf4',
    settingsPath: '/clube?tab=configuracoes',
  },
  reservo: {
    name: 'Reservo',
    description: 'Sistema de reservas de mesas',
    icon: EventAvailableOutlined,
    color: '#7c3aed',
    background: '#f5f3ff',
    settingsPath: '/reservo/configuracoes',
  },
};

export const PAGE_TITLES = {
  overview: {
    title: 'Configurações do restaurante',
    description: 'Cadastre suas unidades, defina os horários de funcionamento e escolha como cada produto utiliza essas informações.',
  },
  units: {
    title: 'Unidades',
    description: 'Cadastre e gerencie as unidades do seu restaurante.',
  },
  hours: {
    title: 'Horários',
    description: 'Defina e gerencie os horários de funcionamento das suas unidades.',
  },
  products: {
    title: 'Produtos e integrações',
    description: 'Escolha como cada produto utiliza os dados das unidades e os horários de funcionamento.',
  },
};

export const CARD_SX = {
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 3,
  boxShadow: '0 8px 28px rgba(15, 23, 42, 0.06)',
  transition: 'border-color 160ms ease, box-shadow 160ms ease',
  '&:hover': {
    transform: 'none',
    borderColor: 'rgba(37, 99, 235, 0.25)',
    boxShadow: '0 12px 32px rgba(15, 23, 42, 0.09)',
  },
};

export const PRIMARY_ACTION_SX = {
  minHeight: 44,
  px: 2.5,
  borderRadius: 2,
  backgroundColor: '#0969da',
  '&:hover': { backgroundColor: '#0757b5' },
};
